import { useUser } from '@/hooks';

export default function useIsOwner() {
  const { data: user, isValidating } = useUser();

  return { data: user?.level === 'Owner', isValidating };
}
